import React from 'react';
import { Translate, withLocalize } from 'react-localize-redux';
import { isNullOrUndefined } from '../../../store/storeFunctions';
import ColorBar from '../../common/colorBar';
import { Link } from "react-router-dom";
import UnderlinedTitle from "../../common/underlinedTitle";
import classnames from 'classnames';


class QuickReportBreakSection extends React.Component {

  render() {
    if (isNullOrUndefined(this.props.value) || isNullOrUndefined(this.props.translationKey))
      return null;

    return (<>
      {this.props.value.breakStart && this.renderInterruptionRow()}

      {/* Uncomment after data change */}
      {/* {(this.props.value.colorBarData && this.props.value.colorBarData.length > 0) && this.renderColorBar()} */}
    </>)
  }

  renderInterruptionRow = () => {
    return <tr className={this.props.className} >
      <td><Translate id={this.props.translationKey} /></td>
      <td> {this.props.value.breakStart && <span><Translate id='Report.TradeInterruptions.From' /> {this.props.value.breakStartFormatted} </span>}
        {this.props.value.breakEnd && <span><Translate id='Report.TradeInterruptions.To' /> {this.props.value.breakEndFormatted} </span>}
      </td>
    </tr>
  }

  renderColorBar = () => {
    return <tr>
      <td colspan="2"><div className={classnames('column is-12', 4)}>
        <div className="box scrn-h-100">
          <UnderlinedTitle header={<Translate id='Report.TradeInterruptions.Title' />} />
          <br />
          <div>
            <span>
              <ColorBar data={this.props.value.colorBarData} sum={this.props.value.totalValue} emptyTooltipText='Report.TradeInterruptions.Active' />
            </span>
          </div>
          <div style={{ marginTop: '5px' }}>
            <span>
              <span style={{ float: 'left' }}>{this.props.value.startDateFormatted}</span><span style={{ float: 'right' }}>{this.props.value.endDateFormatted}</span>
            </span>
          </div>
          <br />
          <table className="table table-report-section-2" style={{ width: '50%', margin: 'auto' }}>
            <thead>
              <tr style={{ backgroundColor: '#f0f0f0' }}>
                <th className="w-40"><Translate id='Report.TradeInterruptions.Detail' /></th>
                <th className="w-30"><Translate id="Report.TradeInterruptions.From" /></th>
                <th className="w-30"><Translate id="Report.TradeInterruptions.To" /></th>
              </tr>
            </thead>
            <tbody>
              {this.props.value.detailData.map((t, i) => {
                return <tr key={i} className="colorize" style={{ backgroundColor: '#fafafa' }}>
                  <td className="w-30" style={{ backgroundColor: '#fafafa' }}><div className={this.getClassNamesByType(t.type)}></div><Translate id={this.getTypeName(t.type)} /></td>
                  <td className="w-70" >{t.startDateFormatted}</td>
                  <td className="w-70">{t.endDateFormatted}</td>
                </tr>

              })}
            </tbody>
          </table>
        </div>
      </div>
      </td></tr>
  }

  getClassNamesByType = (type) => {
    switch (type) {
      case "Enabled": return "tradeInterruptionsDot enabled";
      case "Stopped": return "tradeInterruptionsDot stopped";
      case "Terminated": return "tradeInterruptionsDot terminated";
    }
  }

  getTypeName = (type) => {
    switch (type) {
      case "Enabled": return "Report.TradeInterruptions.Active";
      case "Stopped": return "Report.TradeInterruptions";
      case "Terminated": return "Report.TradeInterruptions.TradeTermination";
    }
  }

  renderDetailRow = (text) => {
    return <tr><td></td><td>{text.tooltipText}</td></tr>
  }
}

const QuickReportBreakRow = withLocalize(QuickReportBreakSection);

export default QuickReportBreakRow;
export { QuickReportBreakRow }
